import React, { useState } from 'react';
import { Link as RouterLink, NavLink, useNavigate } from 'react-router-dom';
import axios from 'axios';

function AdminNavbar({ establishmentId, name = "" }) {
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user_id');
    navigate('/');
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const styles = {
    navbar: {
      backgroundColor: '#0f172a',
      boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
      position: 'sticky',
      top: 0,
      zIndex: 50,
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
      borderBottom: '2px solid #059669'
    },
    container: {
      maxWidth: '1400px',
      margin: '0 auto',
      padding: '0 16px'
    },
    toolbar: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      minHeight: '70px'
    },
    brand: {
      display: 'flex',
      flexDirection: 'column',
      gap: '2px'
    },
    brandTitle: {
      fontSize: '18px',
      fontWeight: '700',
      color: '#ffffff',
      textDecoration: 'none',
      display: 'flex',
      alignItems: 'center',
      gap: '8px'
    },
    establishmentName: {
      fontSize: '12px',
      color: '#94a3b8',
      fontWeight: '500',
      maxWidth: '200px',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    },
    nav: {
      display: 'flex',
      alignItems: 'center',
      gap: '4px'
    },
    navLink: {
      color: '#cbd5e1',
      textDecoration: 'none',
      padding: '10px 16px',
      borderRadius: '8px',
      fontSize: '14px',
      fontWeight: '500',
      transition: 'all 0.2s ease-in-out',
      whiteSpace: 'nowrap',
      position: 'relative'
    },
    navLinkActive: {
      backgroundColor: '#059669',
      color: '#ffffff'
    },
    quickActions: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px'
    },
    homeButton: {
      color: '#94a3b8',
      textDecoration: 'none',
      padding: '8px 12px',
      borderRadius: '6px',
      fontSize: '13px',
      fontWeight: '500',
      transition: 'all 0.2s ease-in-out',
      border: '1px solid #334155'
    },
    logoutButton: {
      backgroundColor: '#dc2626',
      color: '#ffffff',
      border: 'none',
      padding: '10px 16px',
      borderRadius: '8px',
      fontSize: '14px',
      fontWeight: '600',
      cursor: 'pointer',
      transition: 'background-color 0.2s ease-in-out'
    },
    mobileMenuButton: {
      display: 'none',
      backgroundColor: 'transparent',
      border: 'none',
      color: '#ffffff',
      padding: '8px',
      borderRadius: '4px',
      cursor: 'pointer'
    },
    mobileMenu: {
      position: 'absolute',
      top: '100%',
      left: 0,
      right: 0,
      backgroundColor: '#0f172a',
      borderTop: '1px solid #1e293b',
      padding: '16px',
      display: isMobileMenuOpen ? 'block' : 'none',
      maxHeight: '80vh',
      overflowY: 'auto'
    },
    mobileLinkGroup: {
      marginBottom: '20px'
    },
    mobileLinkGroupTitle: {
      color: '#059669',
      fontSize: '12px',
      fontWeight: '700',
      textTransform: 'uppercase',
      letterSpacing: '0.1em',
      marginBottom: '12px',
      padding: '0 16px'
    },
    mobileLink: {
      display: 'block',
      color: '#cbd5e1',
      textDecoration: 'none',
      padding: '14px 16px',
      borderRadius: '8px',
      fontSize: '14px',
      fontWeight: '500',
      marginBottom: '4px',
      transition: 'all 0.2s ease-in-out'
    }
  };

  // Responsive styles
  const mediaQuery = window.matchMedia('(max-width: 1024px)');
  if (mediaQuery.matches) {
    styles.nav.display = 'none';
    styles.mobileMenuButton.display = 'block';
  }

    const navItems = [
    {
      to: `/admin/${establishmentId}`,
      label: 'Établissement',

    },
    {
      to: `/admin/manage-products/${establishmentId}`,
      label: 'Produits',

    },
    {
      to: `/admin/manage-container/${establishmentId}`,
      label: 'Contenants',

    },
    {
      to: `/admin/manage-shop/${establishmentId}`,
      label: 'Boutique',

    }
  ];

  return (
    <nav style={styles.navbar}>
      <div style={styles.container}>
        <div style={styles.toolbar}>
          {/* Brand */}
          <div style={styles.brand}>
            <div style={styles.brandTitle}>
              <span style={{ fontSize: '20px' }}>⚙️</span>
              Administration
            </div>
            {name && (
              <div style={styles.establishmentName} title={name}>
                {name}
              </div>
            )}
          </div>

          {/* Desktop Navigation */}
          <div style={styles.nav}>
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                style={({ isActive }) => ({
                  ...styles.navLink,
                  ...(isActive ? styles.navLinkActive : {})
                })}
                onMouseEnter={(e) => {
                  if (!e.target.classList.contains('active')) {
                    e.target.style.backgroundColor = '#1e293b';
                    e.target.style.color = '#ffffff';
                  }
                }}
                onMouseLeave={(e) => {
                  if (!e.target.classList.contains('active')) {
                    e.target.style.backgroundColor = 'transparent';
                    e.target.style.color = '#cbd5e1';
                  }
                }}
              >
                {item.label}
              </NavLink>
            ))}
          </div>

          {/* Quick Actions */}
          <div style={styles.quickActions}>
            <RouterLink
              to="/accueil"
              style={styles.homeButton}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#1e293b';
                e.target.style.color = '#ffffff';
                e.target.style.borderColor = '#059669';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = 'transparent';
                e.target.style.color = '#94a3b8';
                e.target.style.borderColor = '#334155';
              }}
            >
              ← Accueil
            </RouterLink>

            <button
              onClick={handleLogout}
              style={styles.logoutButton}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#b91c1c';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = '#dc2626';
              }}
            >
              Déconnexion
            </button>

            {/* Mobile Menu Button */}
            <button
              style={styles.mobileMenuButton}
              onClick={toggleMobileMenu}
            >
              <svg width="24" height="24" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth={2} 
                  d={isMobileMenuOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"} 
                />
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        <div style={styles.mobileMenu}>
          <div style={styles.mobileLinkGroup}>
            <div style={styles.mobileLinkGroupTitle}>Navigation</div>
            
            <RouterLink
              to="/accueil"
              style={styles.mobileLink}
              onClick={() => setIsMobileMenuOpen(false)}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#1e293b';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = 'transparent';
              }}
            >
              🏠 Accueil
            </RouterLink>

            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                style={({ isActive }) => ({
                  ...styles.mobileLink,
                  ...(isActive ? { backgroundColor: '#059669', color: '#ffffff' } : {})
                })}
                onClick={() => setIsMobileMenuOpen(false)}
                onMouseEnter={(e) => {
                  if (!e.target.style.backgroundColor.includes('rgb(5, 150, 105)')) {
                    e.target.style.backgroundColor = '#1e293b';
                  }
                }}
                onMouseLeave={(e) => {
                  if (!e.target.style.backgroundColor.includes('rgb(5, 150, 105)')) {
                    e.target.style.backgroundColor = 'transparent';
                  }
                }}
              >
              {item.label}
              </NavLink>
            ))}
          </div>

          <div style={styles.mobileLinkGroup}>
            <button
              onClick={handleLogout}
              style={{
                ...styles.mobileLink,
                backgroundColor: '#dc2626',
                color: '#ffffff',
                border: 'none',
                cursor: 'pointer',
                width: '100%',
                textAlign: 'left'
              }}
            >
              🚪 Déconnexion
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default AdminNavbar;